<template>
  <UserCard
    :title="(isAdmin)? $t('common.roles.admin'): $t('profile.title')"
    :username="`${user.user.first_name} ${user.user.last_name}`"
    :subtitle="lastActive"
    :avatar="profile.image"
    :avatar-editable="useFeature('modify_profile_picture') && isAdmin"
    @change-avatar="changeAvatar"
    @delete-avatar="deleteAvatar"
  >
    Hello,<br>
    <span class="title">{{ user.user.first_name }}.</span><br>
    <span class="subtitle">{{ $moment().format('ll') }}</span>
  </UserCard>
</template>

<script>
import { EventBus } from '@/event-bus';
import UserCard from './UserCard';

export default {
  components: {
    UserCard,
  },
  computed: {
    profile() {
      return this.$store.state.account.user.profile;
    },
    user() {
      return this.$store.state.account.user;
    },
    lastActive() {
      return this.$options.filters.nicedate(this.user.last_active, 'small');
    },
    isAdmin() {
      return this.$store.state.account.isAdminMode;
    },
  },
  methods: {
    changeAvatar(image) {
      EventBus.$emit('avatar-editor--close');
      this.$store.dispatch('profiles/patchProfileImage', {
        id: this.profile.pk,
        image,
      }).then(() => {
        this.$store.dispatch('account/refresh', true);
      });
    },
    deleteAvatar() {
      EventBus.$emit('avatar-editor--close');
      console.log(this.profile.pk);
      this.$store.dispatch('profiles/deleteProfileImage', {
        id: this.profile.pk,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .subtitle {
    color: #646464;
    line-height: 1.25;
    letter-spacing: 0.168814px;
    font-size: 12px;
    font-family: 'SilkaLight';
  }
  .title{
    font-weight: 500;
  }
</style>
